// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__wgJtf","head":"ProcedureTableInfo_head__2nbBm"};